var _polygon, _polygon2, _path, _circle, _circle2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvice(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#005ECE"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00479B"
    },
    d: "M510.849,280.253l-96.289-96.289c-14.658-16.91-36.279-27.622-60.415-27.622 c-6.489,0-12.796,0.777-18.835,2.237l-34.794-34.794l-0.041,0.041H189.217H77.913v208.696l179.46,179.46 C389.954,511.284,498.671,409.813,510.849,280.253z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "77.913,123.826 77.913,332.522 189.217,332.522 244.87,388.174 244.87,332.522  300.522,332.522 300.522,123.826 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BDFDFF"
    },
    points: "189.217,123.826 189.217,332.522 244.87,388.174 244.87,332.522 300.522,332.522  300.522,123.826 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#003F8A"
    },
    points: "203.13,276.87 203.13,207.304 175.304,207.304 175.304,276.87 147.478,276.87  147.478,304.696 175.304,304.696 203.13,304.696 230.957,304.696 230.957,276.87  "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#003F8A"
    },
    cx: 189.217,
    cy: 172.522,
    r: 20.87
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M418.098,388.174H290.19v-7.994c0-35.32,28.633-63.953,63.953-63.953l0,0 c35.32,0,63.953,28.633,63.953,63.953v7.994H418.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1E3FA"
    },
    d: "M370.134,316.226h-15.989v71.948h63.953v-23.983C418.098,337.701,396.624,316.226,370.134,316.226z"
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "370.134,388.174 354.145,388.174 338.156,388.174 354.145,308.232 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "354.145,340.208 370.134,316.226 338.156,316.226 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E3D42"
    },
    d: "M290.19,364.191v23.983h63.953l-23.77-71.31C307.586,320.583,290.19,340.351,290.19,364.191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D2D30"
    },
    d: "M377.915,316.863l-23.77,71.31h63.953v-23.983C418.098,340.351,400.703,320.583,377.915,316.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D1D1F"
    },
    d: "M354.145,156.341L354.145,156.341c-12.82,0-24.932,3.023-35.671,8.387 c-1.396-0.253-2.832-0.392-4.301-0.392c-13.244,0-23.981,10.735-23.983,23.978c-0.081,0.108-0.161,0.216-0.242,0.324 c-13.441,2.042-23.741,13.648-23.741,27.66c0,7.624,3.053,14.533,7.999,19.58c-0.001,0.136-0.006,0.27-0.006,0.406v31.977h159.885 v-31.977C434.087,192.132,398.296,156.341,354.145,156.341z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M354.145,156.341L354.145,156.341V268.26h79.942v-31.977C434.087,192.132,398.296,156.341,354.145,156.341z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC477"
    },
    d: "M306.179,284.249H290.19c-8.794,0-15.989-7.195-15.989-15.989l0,0 c0-8.794,7.195-15.989,15.989-15.989h15.989V284.249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB655"
    },
    d: "M402.11,284.249h15.989c8.794,0,15.989-7.195,15.989-15.989l0,0c0-8.794-7.195-15.989-15.989-15.989 H402.11V284.249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDAAA"
    },
    d: "M380.668,227.329c-2.54-1.904-4.935-3.912-7.194-5.999c-22.803,14.808-49.632,22.949-77.418,22.949 h-13.416c-0.29,2.626-0.444,5.291-0.444,7.994c0,39.736,32.213,71.948,71.948,71.948s71.948-32.213,71.948-71.948 c0-2.726-0.157-5.415-0.452-8.062C410.909,243.614,394.896,238,380.668,227.329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC477"
    },
    d: "M425.64,244.21c-14.731-0.595-30.746-6.21-44.974-16.88c-2.54-1.904-4.935-3.912-7.194-5.999 c-6.167,4.006-12.632,7.519-19.329,10.518v92.371c39.736,0,71.948-32.213,71.948-71.948 C426.093,249.547,425.936,246.857,425.64,244.21z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 316.505,
    cy: 262.6,
    r: 10.326
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.78,
    cy: 262.6,
    r: 10.326
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F072AE"
    },
    d: "M354.145,308.232c13.245,0,23.983-10.738,23.983-23.983h-47.965 C330.162,297.494,340.9,308.232,354.145,308.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED539D"
    },
    d: "M354.145,284.249v23.983c13.245,0,23.983-10.738,23.983-23.983H354.145z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvice);
export default __webpack_public_path__ + "static/media/advice.202475fbcd3ddeff4bdaa5ac773f4674.svg";
export { ForwardRef as ReactComponent };